import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Grid,
  Checkbox,
  FormControlLabel,
  makeStyles,
  FormControl,
  Select,
  MenuItem,
  TextareaAutosize,
} from "@material-ui/core";
import { FrolaEditor } from "../../../../../../components/common";
import { ValidatorForm } from "react-material-ui-form-validator";

const platforms = [
  "Facebook",
  "Instagram",
  "Shopify",
  "Accounts",
  "IOS",
  "Android",
];
const useStyles = makeStyles(theme => ({
  platforms: {
    padding: "12px",
  },
  selectEmpty: {
    "& .MuiInputBase-input": {
      border: "1px solid rgba(0, 0, 0, 0.23) !important",
      borderRadius: "6px",
      background: "unset !important",
    },
  },
  categoryId: {
    fontSize: "14px",
    color: "#2d3339",
    fontWeight: 500,
    marginBottom: "6px",
    lineHeight: "35px",
  },
  textAreaSize: {
    minHeight: "unset !important",
    background: "unset !important",
  },
  floraEditor: {
    "& .fr-view": {
      maxWidth: "unset !important",
    },
    '& [data-cmd="insertImage"]': {
      display: "none",
    },
    '& [data-cmd="insertVideo"]': {
      display: "none",
    },
  },
  button: {
    marginBottom: "15px !important",
  },
  questInfoText: {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "35px",
    marginBottom: "6px",
    color: "#49b8ef",
  },
}));

const priorityList = [
  { label: "Highest", value: 1 },
  { label: "High Medium", value: 2 },
  { label: "Medium", value: 3 },
  { label: "Low Medium", value: 4 },
  { label: "Lowest", value: 5 },
];

export const AddUpdateFaqForm = ({
  handleSubmit,
  values,
  setValues,
  faqsCategoryData,
  subCategoryData,
}) => {
  const classes = useStyles();
  const [isFormValid, setIsFormValid] = useState(false);

  const handleInputChange = (name, value) => {
    setValues({
      ...values,
      [name]: value,
    });
  };

  useEffect(() => {
    validateForm();
  }, [values]);

  const handleCheckboxChange = event => {
    const { checked, value } = event.target;
    let updatedPlatforms = [...values.platForm];

    if (checked) {
      if (!updatedPlatforms.includes(value)) {
        updatedPlatforms.push(value);
      }
    } else {
      updatedPlatforms = updatedPlatforms.filter(
        platform => platform !== value
      );
    }

    setValues({
      ...values,
      platForm: updatedPlatforms,
    });
  };

  const validateForm = () => {
    const { categoryId, question, answer, subCategoryId } = values;
    const isValid =
      categoryId !== 0 &&
      subCategoryId !== 0 &&
      question?.trim() !== "" &&
      answer?.trim() !== "";
    setIsFormValid(isValid);
  };

  return (
    <ValidatorForm
      ref={useRef("form")}
      onSubmit={() => {
        handleSubmit(values);
      }}>
      <Grid className={classes.selectEmpty} container spacing={3}>
        <Grid item xs={6}>
          <span className={classes.categoryId}>Category</span>
          <FormControl fullWidth variant='outlined'>
            <Select
              labelId='category-label'
              id='categoryId'
              name='categoryId'
              value={values.categoryId}
              onChange={({ target }) =>
                handleInputChange("categoryId", target.value)
              }
              required
              MenuProps={{
                PaperProps: {
                  style: {
                    width: "100%",
                    maxWidth: 600,
                    minWidth: "unset",
                  },
                },
              }}>
              {faqsCategoryData.map(category => (
                <MenuItem key={category.id} value={category.id}>
                  {category.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <span className={classes.categoryId}>Priority</span>
          <FormControl fullWidth variant='outlined'>
            <Select
              labelId='priority-label'
              id='priority'
              name='priority'
              value={values.priority}
              onChange={({ target }) =>
                handleInputChange("priority", target.value)
              }
              required
              MenuProps={{
                PaperProps: {
                  style: {
                    width: "100%",
                    maxWidth: 600,
                    minWidth: "unset",
                  },
                },
              }}>
              {priorityList.map(category => (
                <MenuItem key={category.label} value={category.value}>
                  {category.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <span className={classes.categoryId}>Sub Category</span>
          <FormControl fullWidth variant='outlined'>
            <Select
              labelId='subCategoryId-label'
              id='subCategoryId'
              name='subCategoryId'
              value={values.subCategoryId}
              onChange={({ target }) =>
                handleInputChange("subCategoryId", target.value)
              }
              required
              MenuProps={{
                PaperProps: {
                  style: {
                    width: "100%",
                    maxWidth: 600,
                    minWidth: "unset",
                  },
                },
              }}>
              {subCategoryData.map(category => (
                <MenuItem key={category.id} value={category.id}>
                  {category.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <span className={classes.categoryId}>
            Question{" "}
            <span className={classes.questInfoText}>(Upto 100 chracters)</span>
          </span>
          <TextareaAutosize
            className={classes.textAreaSize}
            maxRows={2}
            aria-label='maximum height'
            name='question'
            placeholder={"Write your question..."}
            value={values.question}
            onChange={event => {
              if (event.target.value.length < 100) {
                handleInputChange("question", event.target.value);
              }
            }}
          />
        </Grid>
        <Grid className={classes.floraEditor} item xs={12}>
          <FrolaEditor
            model={values?.answer}
            conversationPlateform={"Shopify"}
            onHandleModelChange={model => handleInputChange("answer", model)}
            comDescription={values?.answer}
            placeholder={"Write the answer here..."}
          />
        </Grid>
        <Grid className={classes.platforms}>
          <h3>Platforms</h3>
          <Grid container xs={12}>
            {platforms.map((platform, index) => (
              <Grid item xs={6}>
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={values.platForm?.includes(platform)}
                      onChange={handleCheckboxChange}
                      value={platform}
                      color='primary'
                    />
                  }
                  label={platform}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent='flex-end'
          className={classes.button}
          item
          xs={12}>
          <Button
            disabled={!isFormValid}
            type='submit'
            variant='contained'
            color='primary'>
            Submit
          </Button>
        </Grid>
      </Grid>
    </ValidatorForm>
  );
};
